const BASE_URL = process.env.REACT_APP_URL;

export default function Home() {
  window.location.href = `${BASE_URL}/redirect`;
  return null;
}
